module.exports = __webpack_public_path__ + "static/for-customers@3x-b641803526cbc099bb17ff8cda3cd23c.jpg";